var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vuestic-file-upload",
      class: { "vuestic-file-upload--dropzone": _vm.dropzone },
    },
    [
      _c(
        "vuestic-file-upload-container",
        {
          attrs: {
            type: _vm.type,
            fileTypes: _vm.fileTypes,
            dropzone: _vm.dropzone,
          },
          on: { upload: _vm.uploadFile },
        },
        [
          _vm.files.length
            ? _c("vuestic-file-upload-list", {
                attrs: {
                  type: _vm.type,
                  files: _vm.files,
                  isShowDelete: _vm.isShowDelete,
                },
                on: {
                  remove: _vm.removeFile,
                  "remove-single": _vm.removeSingleFile,
                },
              })
            : _vm._e(),
          _c(
            "vuestic-modal",
            { ref: "mediumModal", attrs: { "no-buttons": true } },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v(_vm._s(_vm.$t("fileUpload.modalTitle"))),
              ]),
              _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("fileUpload.modalText")) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }